import { atom } from 'jotai';

export const videoPanelOpenAtom = atom(false);
